module.exports = __webpack_public_path__ + "static/media/upload-image.dee75d72.png";